import React, { useState, useEffect } from "react";
import "./Newsletter.css";
import Footer from "./Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faArrowRight,
	faClock,
	faUser,
	faTimes,
	faSearch,
} from "@fortawesome/free-solid-svg-icons";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../firebase-config";

function Newsletter() {
	const [newsletters, setNewsletters] = useState([]);
	// eslint-disable-next-line
	const [loading, setLoading] = useState(true);
	const [selectedNewsletter, setSelectedNewsletter] = useState(null);
	const [searchTerm, setSearchTerm] = useState("");
	const [filteredNewsletters, setFilteredNewsletters] = useState([]);

	useEffect(() => {
		const fetchNewsletters = async () => {
			try {
				const newslettersQuery = query(
					collection(db, "newsletters"),
					orderBy("createdAt", "desc")
				);
				const querySnapshot = await getDocs(newslettersQuery);
				const fetchedNewsletters = querySnapshot.docs.map((doc) => ({
					id: doc.id,
					...doc.data(),
				}));
				setNewsletters(fetchedNewsletters);
				setFilteredNewsletters(fetchedNewsletters);
			} catch (error) {
				console.error("Error fetching newsletters:", error);
			} finally {
				setLoading(false);
			}
		};

		fetchNewsletters();
	}, []);

	useEffect(() => {
		const results = newsletters.filter((newsletter) =>
			Object.values(newsletter).some((value) =>
				value?.toString().toLowerCase().includes(searchTerm.toLowerCase())
			)
		);
		setFilteredNewsletters(results);
	}, [searchTerm, newsletters]);

	const openModal = (newsletter) => {
		setSelectedNewsletter(newsletter);
		document.body.style.overflow = "hidden"; // Prevent scrolling when modal is open
	};

	const closeModal = () => {
		setSelectedNewsletter(null);
		document.body.style.overflow = "unset"; // Re-enable scrolling
	};

	return (
		<div className="main-container">
			<div className="blog-search-container">
				<div className="blog-search-wrapper">
					<FontAwesomeIcon icon={faSearch} className="search-icon" />
					<input
						type="text"
						placeholder="Search newsletters..."
						value={searchTerm}
						onChange={(e) => setSearchTerm(e.target.value)}
						className="blog-search-input"
					/>
				</div>
				{searchTerm && (
					<p className="search-results-count">
						Found {filteredNewsletters.length}{" "}
						{filteredNewsletters.length === 1 ? "result" : "results"}
					</p>
				)}
			</div>

			<div className="blog-grid">
				{filteredNewsletters.map((newsletter) => (
					<article key={newsletter.id} className="blog-card">
						<div className="blog-card-image">
							<img src={newsletter.imageUrl} alt={newsletter.title} />
						</div>
						<div className="blog-card-content">
							<h2>{newsletter.title}</h2>
							<p>{newsletter.excerpt}</p>
							<div className="blog-card-meta">
								<span>
									<FontAwesomeIcon icon={faUser} /> {newsletter.author}
								</span>
								<span>
									<FontAwesomeIcon icon={faClock} /> {newsletter.readTime}
								</span>
							</div>
							<button
								className="read-more-button"
								onClick={() => openModal(newsletter)}
							>
								Read More
								<FontAwesomeIcon icon={faArrowRight} />
							</button>
						</div>
					</article>
				))}
				{filteredNewsletters.length === 0 && !loading && (
					<div className="no-results">
						<p>No newsletters found matching your search.</p>
					</div>
				)}
			</div>

			{/* Newsletter Modal */}
			{selectedNewsletter && (
				<div className="blog-modal-overlay" onClick={closeModal}>
					<div
						className="blog-modal-content"
						onClick={(e) => e.stopPropagation()}
					>
						<button className="blog-modal-close" onClick={closeModal}>
							<FontAwesomeIcon icon={faTimes} />
						</button>
						<div className="blog-modal-image">
							<img
								src={selectedNewsletter.imageUrl}
								alt={selectedNewsletter.title}
							/>
						</div>
						<div className="blog-modal-body">
							<h2>{selectedNewsletter.title}</h2>
							<div className="blog-modal-meta">
								<span>
									<FontAwesomeIcon icon={faUser} /> {selectedNewsletter.author}
								</span>
								<span>
									<FontAwesomeIcon icon={faClock} />{" "}
									{selectedNewsletter.readTime}
								</span>
							</div>
							<div className="blog-modal-text">
								{selectedNewsletter.content}
							</div>
						</div>
					</div>
				</div>
			)}

			<Footer />
		</div>
	);
}

export default Newsletter;
